"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var fix_parent_1 = require("./fix$parent");
var funcParams_1 = require("./funcParams");
var schemaPath_1 = require("./schemaPath");
var cacheFuncs = {};
function validFunction(schema, validFunc, cache, debug) {
    if (cache === void 0) { cache = true; }
    var func = null;
    if (validFunc) {
        var stext = '';
        if (Array.isArray(validFunc)) {
            stext = validFunc.join('\r\n');
        }
        else {
            stext = validFunc;
            if (stext.indexOf('{') === -1) {
                stext = "$result=(" + stext + ");";
            }
        }
        if (cache && !debug) {
            func = cacheFuncs['valid_' + stext];
            if (func !== undefined) {
                return func;
            }
        }
        // let ftext = '';
        // stext = fix$parent(stext);
        var ffunc = "var $value=$obj.$model;\r\nvar $result=null;\r\n";
        if (debug) {
            func += "/*** function body ***/\r\n";
        }
        ffunc += "" + (0, fix_parent_1.default)(stext);
        // ffunc+=`${}`;
        // ffunc += 'with($data) {';
        // ffunc += `with(parent) ${stext};`;
        // ffunc += '};';
        // ffunc += `console.log('validFuncResult','${propName}',$result);`;
        // nie ma potrzeby, return i tak zadziała wcześniej
        /*
            if (stext.indexOf('return ') === -1) {
                ffunc += '\r\nreturn $result;';
            }
            */
        ffunc += '\r\nreturn $result;';
        if (debug) {
            ffunc = "\r\n/*** " + (0, schemaPath_1.default)(schema, true) + " validFunc ***/\r\nvar $objpath = $obj.$path; // model path\r\ndebugger;\r\n\r\n" + ffunc;
            // ffunc = 'console.debug($obj.$path);\r\ndebugger;\r\n' + ffunc;
        }
        // old
        /*
            ftext += `return (${stext});`;
    
    
    
            if (debug && !debug) {
                ftext = 'debugger;\r\n' + ftext;
            }
            */
        func = new Function(funcParams_1.default, ffunc);
        if (cache) {
            cacheFuncs['valid_' + stext] = func;
        }
    }
    return func;
}
exports.default = validFunction;
//# sourceMappingURL=validFunction.js.map